import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { IEstadoCvStore, IModelAccion, IModelCurriculum, IReporteCV } from 'src/model/candidato-api'

import './panel-cv-print.scss'

class PanelCvPrintComponentCtrl implements ng.IComponentController {
  cv!: { cv: IModelCurriculum }

  report: IReporteCV
  $loading = false

  statesStore: IEstadoCvStore | undefined

  history = {
    list: [] as IModelAccion[],
    show: true,
  }

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelCvPrintComponentCtrl] onInit')

    this._leerCV().then(() => {
      this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then((responseTipos) => {
        this.statesStore = responseTipos.estados
      })
    })
  }

  $postLink() {
    $('body').css('overflow', 'auto')
  }

  private _leerCV() {
    this.$loading = true
    return this.AccesoDatos.GestionCurr_CLIENT.leerCv(this.cv.cv.form_id, this.cv.cv.idcv).then((reportResponse) => {
      this.report = reportResponse
      this.history.list = reportResponse.history.list

      this.$loading = false
    })
  }

  _refreshcv() {
    this.report = null

    this._leerCV()
  }

  toggleHistory() {
    this.history.show = !this.history.show
  }
}

angular.module('candidato').component('panelCvPrint', {
  bindings: {
    cv: '<',
  },
  controller: PanelCvPrintComponentCtrl,
  // templateUrl: "panel-cv-print.component.html",
  template: require('./panel-cv-print.component.html'),
})
